import img1 from "../assets/images/ourwork/somo.jpg";
import img2 from "../assets/images/ourwork/cityofframes.jpg";
import img3 from "../assets/images/ourwork/Anata.jpg";
import img5 from "../assets/images/ourwork/pkad.jpg";
import img6 from "../assets/images/ourwork/tql.jpg";
import img8 from "../assets/images/logo/fat LuLu.jpg";
import img9 from "../assets/images/ourwork/kunalkapoor.jpg";
import img11 from "../assets/images/ourwork/afterhours.jpg";
import img13 from "../assets/images/ourwork/kylin.jpg";
import img14 from "../assets/images/ourwork/daryaganj.jpg";
import img17 from "../assets/images/ourwork/startupstairs.jpg";
import img19 from "../assets/images/ourwork/worldmark.jpg";
import img4  from '../assets/images/ourwork/chathpooja.jpg';
import img7 from '../assets/images/ourwork/pcj.jpg';
import img20 from '../assets/images/ourwork/hki.png';
import img10 from '../assets/images/ourwork/preetmamevent.jpg';
import img12 from '../assets/images/ourwork/kingfisher.jpg';

const PCJ_VIDEO_URL =
  "https://hki-web-public-assets.s3.ap-south-1.amazonaws.com/hki-3.0-content/PCJ+Final+3+(1).mp4";

const PREET_MAAM_VIDEO_URL =
  "https://hki-web-public-assets.s3.ap-south-1.amazonaws.com/hki-3.0-content/Preet+Maam+Event+video.mp4";

const AWS_VIDEO_URLS = [
  "https://hki-web-public-assets.s3.ap-south-1.amazonaws.com/hki-3.0-content/pk_ad.mp4",
  "https://hki-web-public-assets.s3.ap-south-1.amazonaws.com/hki-3.0-content/chatt_pooja_final.mp4",
  "https://hki-web-public-assets.s3.ap-south-1.amazonaws.com/hki-3.0-content/startup_stairs_leela.mp4",
  "https://hki-web-public-assets.s3.ap-south-1.amazonaws.com/hki-3.0-content/anaita_dhondy.mp4",
  "https://hki-web-public-assets.s3.ap-south-1.amazonaws.com/hki-3.0-content/bohosvilla_2.mp4",
  "https://hki-web-public-assets.s3.ap-south-1.amazonaws.com/hki-3.0-content/bohosvilla_3.mp4",
  "https://hki-web-public-assets.s3.ap-south-1.amazonaws.com/hki-3.0-content/bohosvilla.mp4",
  "https://hki-web-public-assets.s3.ap-south-1.amazonaws.com/hki-3.0-content/chef_kunal_kapoor.mp4",
  "https://hki-web-public-assets.s3.ap-south-1.amazonaws.com/hki-3.0-content/daryaganj.mp4",
  "https://hki-web-public-assets.s3.ap-south-1.amazonaws.com/hki-3.0-content/fat_lulu_s.MP4",
  "https://hki-web-public-assets.s3.ap-south-1.amazonaws.com/hki-3.0-content/goodtimes.mp4",
  "https://hki-web-public-assets.s3.ap-south-1.amazonaws.com/hki-3.0-content/kingfisher.mp4",
  "https://hki-web-public-assets.s3.ap-south-1.amazonaws.com/hki-3.0-content/kylin+_experience.mp4",
  "https://hki-web-public-assets.s3.ap-south-1.amazonaws.com/hki-3.0-content/one8_commune.mp4",
  "https://hki-web-public-assets.s3.ap-south-1.amazonaws.com/hki-3.0-content/somo_s+_patisserie.mp4",
  "https://hki-web-public-assets.s3.ap-south-1.amazonaws.com/hki-3.0-content/vidssave.com+Mexican+Sausage+Bake+_+For+the+entire+recipe+Click+on+link+in+the+comment+box!+720P.mp4",
];
export const works = [
  { id: "pk-ad", title: "Punjab Kings", category: "Ad Film", year: "2024", media: { type: "video", src: AWS_VIDEO_URLS[0], poster: img5 } },
  { id: "pcj-final-3", title: "PC Jewellers", category: "Campaign Film", year: "2024", media: { type: "video", src: PCJ_VIDEO_URL, poster: img7 } },
  { id: "startup-stairs-leela", title: "Startup Stairs", category: "Brand Film", year: "2024", media: { type: "video", src: AWS_VIDEO_URLS[2], poster: img17 } },
  { id: "preet-maam-event", title: "Events & Experiences", category: "Event Film", year: "2024", media: { type: "video", src: PREET_MAAM_VIDEO_URL, poster: img10 } },

  { id: "the-quiet-launch", title: "Bohos Villa", category: "Product Launch", year: "2023", media: { type: "video", src: AWS_VIDEO_URLS[5], poster: img6 } },

  { id: "second-nature", title: "Chef Kunal Kapoor", category: "Social Campaign", year: "2023", media: { type: "video", src: AWS_VIDEO_URLS[7], poster: img9 } },

  { id: "kfc-launch", title: "Kingfisher", category: "Brand Film", year: "2024", media: { type: "video", src: "https://hki-web-public-assets.s3.ap-south-1.amazonaws.com/hki-3.0-content/KFC.mp4", poster: img12 } },
  
  { id: "unscripted", title: "Daryaganj", category: "Brand Film", year: "2024", media: { type: "video", src: AWS_VIDEO_URLS[8], poster: img14 } },
  { id: "after-hours", title: "Bohos Villa", category: "Ad Film", year: "2024", media: { type: "video", src: AWS_VIDEO_URLS[4], poster: img11 } },
  { id: "signal-through-noise", title: "Anahita Dhondy", category: "Brand Film", year: "2024", media: { type: "video", src: AWS_VIDEO_URLS[3], poster: img3 } },
  
  { id: "city-of-frames", title: "Bohos Villa", category: "Documentary", year: "2024", media: { type: "video", src: AWS_VIDEO_URLS[6], poster: img2 } },
  
  { id: "north-star", title: "Kylin Experience", category: "Campaign Film", year: "2023", media: { type: "video", src: AWS_VIDEO_URLS[12], poster: img13 } },
  { id: "static", title: "WorldMark", category: "Music Film", year: "2024", media: { type: "video", src: AWS_VIDEO_URLS[13], poster: img19 } },
  
  { id: "the-last-cut", title: "Somo Pizzeria", category: "Brand Film", year: "2024", media: { type: "video", src: AWS_VIDEO_URLS[14], poster: img1 } },

  { id: "chatt-pooja-final", title: "Gigmatic.ai", category: "Campaign Film", year: "2024", media: { type: "video", src: AWS_VIDEO_URLS[1], poster: img4 } },


  { id: "the-long-take", title: "Fat Lulu", category: "Experiential", year: "2024", media: { type: "video", src: AWS_VIDEO_URLS[9], poster: img8 } },
];